import type { TmWrappers } from '@/wrappers'

export const allowedEmailsAddModalId: TmWrappers = 'allowedEmailsAddModal'

export type AllowedEmailPutBody = {
  email: string
  htmlHistory: boolean
  sendReplies: boolean
  showHistory: boolean
}

export type AllowedEmailPutResponseBody = {
  rightEmails: string[]
  wrongEmails: string[]
}

export interface AllowedEmailsEditSettingsFormSchema {
  email: string
  sendReplies: boolean
  showHistory: boolean
  htmlHistory: boolean
}

export interface AllowedEmailsAddFormSchema {
  emails: string[]
}
